var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-unstyled text-center py-2"},[_c('a',{staticClass:"text-decoration-none text-uppercase",attrs:{"href":_vm.url}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }